import React, { useState } from 'react'
import { Page } from '../../components'
import Editor, { getEmptyParagraph } from 'bxl-editor'
import LegoService from '@services/lego'
import './index.scss'

// freestyle editor playground
const Playground = () => {
  const [value, onChange] = useState<any>([getEmptyParagraph()])
  const onSimpleRequest = (options, onProgress): Promise<any> => {
    const { file, name, extension, width, height } = options
    const form = new FormData()
    form.append('content', file, name + '.' + extension)
    form.append('fulldim', `${width}x${height}`)
    form.append('format', extension)
    form.append('path', 'playground/' + name + '.' + extension)
    return LegoService.uploadImg(form, onProgress)
  }

  const parseImageResponse = (res: any) => {
    return {
      width: res.options?.width || 0,
      height: res.options?.height || 0,
      url: res.url,
    }
  }

  return (
    <Page inner>
      <Editor
        value={value}
        onChange={onChange}
        options={{
          uploadImage: onSimpleRequest,
          parseImageResponse: parseImageResponse,
        }}
      />
    </Page>
  )
}

export default Playground
